import React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  Button,
  IconButton,
} from "@mui/material";
import { X as CloseIcon, CheckCircle as CheckCircleIcon } from "lucide-react";

const ConfirmationModal = ({
  open,
  onClose,
  title,
  message,
  confirmLabel = "SAVE",
  cancelLabel = "CANCEL",
  onConfirm,
  showSuccess = false,
  image = null, // New optional prop for image
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      // maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          p: 5,
          m:0
        },
      }}
    >
      {/* <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8
          ,p:0,m:0
        }}
      >
        <CloseIcon />
      </IconButton> */}

      <DialogContent sx={{ textAlign: "center", py: 0 }}>
        {showSuccess ? (
          <>
            <Box sx={{ mb: 2}}>
              <CheckCircleIcon color="success" size={48} />
            </Box>
            <Typography variant="h5" gutterBottom sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem',m:5 } }}>
              {title}
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>
              {message}
            </Typography>
          </>
        ) : (
          <>
            <Typography variant="h5" gutterBottom sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem',} }}>
              {title}
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4, fontSize: { xs: '0.875rem', sm: '1rem' } }}>
              {message}
            </Typography>
            <Box sx={{ display: "flex", gap: 2, justifyContent: "center", flexDirection: { xs: "column", sm: "row" } }}>
              <Button
                variant="outlined"
                onClick={onClose}
                sx={{ px: 4, borderRadius: 2, width: { xs: '100%', sm: 'auto' } }}
              >
                {cancelLabel}
              </Button>
              <Button
                variant="contained"
                onClick={onConfirm}
                sx={{
                  px: 4,
                  borderRadius: 2,
                  bgcolor: (theme) => theme.palette.secondary.main,
                  "&:hover": {
                    bgcolor: (theme) => theme.palette.secondary.dark,
                  },
                  width: { xs: '100%', sm: 'auto' },
                }}
              >
                {confirmLabel}
              </Button>
            </Box>
          </>
        )}
      </DialogContent>

      {image && (
        <DialogContent sx={{ textAlign: "center", py: 0 ,p:0,m:0}}>
          <Box sx={{ mb: 0 }}>
            <img
              src={image}
              alt="modal image"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          </Box>
        </DialogContent>
      )}
    </Dialog>
  );
};

export default ConfirmationModal;
